import IframeResizerEnum from "../enumerators/iframe-resizer.enum";

export default class IframeResizerService {
    constructor() {
        if ($(IframeResizerEnum.IFRAME_ELEMENT).length > 0) {
            import(
                '../actions/iframe-resizer.action' /* webpackChunkName: "scripts/iframe-resizer.action" */
                ).then(({default: IframeResizerAction}) => {
                new IframeResizerAction()
            })
        }
    }
}
